import LinkText from 'lang/LinkText'
import Translate from 'lang/Translate'
import TranslateParse from 'lang/TranslateParse'
import { Fragment } from 'react'
import { Trans } from 'react-i18next'

const PageNotFoundError = () => {
  return (
    <Fragment>
      <div className="tile">
        <div className="error-content">
          <h3><Translate text="Content.pageNotFoundTableHeader" /></h3>
          <div>
            <TranslateParse 
              text="Content.pageNotFoundTableRow1"
              inject={[
                { 
                  linkText: "Content.pageNotFoundTableRow1Link", 
                  renderItem: <LinkText to="https://prosupport.hrblock.ca/en-ca/Content/0ProSupport/VDOPro/ClearingCookies.htm"/> 
                }
              ]}
            />
          </div>
          <div>
            <Trans i18nKey="Content.pageNotFoundTableRow2" />
          </div>
          <div className="mt-5 mb-2">
            <h3><Translate text="Content.pageNotFoundStillGettingError" /></h3>
          </div>
          <div>
            <TranslateParse 
              text="Content.pageNotFoundDescribeYourIssue"
              inject={[
                { 
                  linkText: "Content.createABlockSignalLink", 
                  renderItem: <LinkText to="https://hrbcaprod.service-now.com/hrb/"/> 
                }
              ]}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default PageNotFoundError